module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_prp02-9eaa5d5092127da4f02a2af2e7921818.svg";